import { Card } from "antd";
import { Bar } from "react-chartjs-2";

export const BookingPickup = (props) => {
  const { chartData, monthYear } = props;
  return (
    <Card style={{ margin: "20px auto", textAlign: "center" }} bordered>
      <h2 style={{ marginBottom: "20px" }}>
        {monthYear} (MTD Booking Picked Up)
      </h2>
      {chartData ? (
        <Bar
          data={chartData}
          options={{
            responsive: true,
            plugins: {
              legend: { display: false },
              tooltip: {
                callbacks: {
                  label: (context) => `Bookings: ${context.raw}`,
                },
              },
              datalabels: {
                display: true,
                color: "black",
                font: { size: 12, weight: "bold" },
                anchor: "end",
                align: "end",
                formatter: (value) => (value > 0 ? value : ""),
              },
            },
            scales: {
              x: {
                title: { display: true, text: "Date" },
                ticks: {
                  callback: (value, index) => {
                    // chartData.labels is "YYYY-MM-DD" (assuming your API returns that)
                    // We want to display just day of month
                    const date = chartData.labels[index];
                    return date.split("-")[2];
                  },
                },
              },
              y: {
                title: { display: true, text: "Number of Bookings" },
                beginAtZero: true,
              },
            },
          }}
        />
      ) : (
        <p>Loading booking chart...</p>
      )}
    </Card>
  );
};
